const NotFoundView = () => {
    return <>404 Error</>
}

export default NotFoundView